class General {
    static formatVideo(file){
        if(!file) return '';
        const fileExt = this.getUrlExtension(file);
        const format = {
            opus: 'video/ogg',
            ogv: 'video/ogg',
            mp4: 'video/mp4',
            mov: 'video/mp4',
            m4v: 'video/mp4',
            mkv: 'video/x-matroska',
            m4a: 'audio/mp4',
            mp3: 'audio/mpeg',
            aac: 'audio/aac',
            caf: 'audio/x-caf',
            flac: 'audio/flac',
            oga: 'audio/ogg',
            wav: 'audio/wav',
            m3u8: 'application/x-mpegURL',
            mpd: 'application/dash+xml',
            jpg: 'image/jpeg',
            jpeg: 'image/jpeg',
            gif: 'image/gif',
            png: 'image/png',
            svg: 'image/svg+xml',
            webp: 'image/webp'
        }

        return format[fileExt]
    }
    static getUrlExtension(url){
        return url.split(/[#?]/)[0].split('.').pop().trim();
    }

    static getCookie(name) {
        const value = `; ${document.cookie}`;
        const parts = value.split(`; ${name}=`);
        if (parts.length === 2) return parts.pop().split(';').shift();
    }

    static downloadByUrl(url, fileName) {
        return new Promise((resolve, reject) => {
            try {
                var xhr = new XMLHttpRequest();
                xhr.open("GET", url, true);
                xhr.responseType = "blob";
                xhr.onload = function(){
                    var urlCreator = window.URL || window.webkitURL;
                    var imageUrl = urlCreator.createObjectURL(this.response);
                    var tag = document.createElement('a');
                    tag.href = imageUrl;
                    tag.download = fileName;
                    document.body.appendChild(tag);
                    tag.click();
                    document.body.removeChild(tag);
                    resolve(true);
                }
                xhr.send();
            } catch (error) {
                reject(error);
            }
        })
    }

    static getFileNameFromUrl(url) {
        return url.substring(url.lastIndexOf("/") + 1);
    }
    
    static getNumber(str) {
        return Number(str.replace(/[^0-9]/g, ''));
    }

    static formattedSkpPoint(skpPoint) {
        const numericSkpPoint = parseFloat(skpPoint);
        if (!numericSkpPoint || isNaN(numericSkpPoint)) return 0;
        return numericSkpPoint.toLocaleString('id-ID', { minimumFractionDigits: 0, maximumFractionDigits: numericSkpPoint % 1 ? 2 : 0 });
    }
}

export default General;